<template>
    <div class="content">
        {{ dataMsg }}
    </div>
</template>

<script>
import { getWeDetail } from '@/api/index'
export default {
    data() {
        return {
            dataMsg: ''
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            getWeDetail().then((res) => {
                if (res.code == 0) {
                    this.dataMsg = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 30px;
    box-sizing: border-box;
}
</style>